'use client';

import {
  Avatar,
  Box,
  Button,
  Divider,
  SystemIcon,
  Typography,
} from '@wishket/design-system';
import { twJoin, twMerge } from 'tailwind-merge';

interface NotificationListProps {
  texts: string[];
}

const NotificationList = ({ texts }: NotificationListProps) => {
  return (
    <ul className="flex flex-col gap-1">
      {texts.map((text) => (
        <li className="flex items-center gap-2" key={text}>
          <Box className="size-1 rounded-full bg-w-gray-200" />
          <Typography variant="body2" className="text-w-gray-500">
            {text}
          </Typography>
        </li>
      ))}
    </ul>
  );
};

interface ProfileImageFormProps {
  profileImgSrc?: string;
  onUpload: () => void;
  onDelete: () => void;
  onClose: () => void;
  onSubmit: () => void;
}

const ProfileImageForm = ({
  profileImgSrc,
  onUpload,
  onDelete,
  onClose,
  onSubmit,
}: ProfileImageFormProps) => {
  return (
    <Box className="flex h-dvh w-full flex-col justify-between desktop:h-fit">
      <Box>
        <Box className="flex h-[60px] items-center justify-between border-b px-5 desktop:h-fit desktop:px-8 desktop:py-6">
          <Box className="block size-6 desktop:hidden" />
          <Typography
            variant="subTitle2"
            className="font-medium text-w-gray-900"
          >
            프로필 사진 등록
          </Typography>
          <button onClick={onClose}>
            <SystemIcon name="large_delete" className="text-w-gray-600" />
          </button>
        </Box>
        <Box className="flex flex-col items-center gap-8 p-8">
          <Avatar
            imgUrl={profileImgSrc}
            size="xl"
            data-id="profile-image-manage-modal-avatar"
          />
          <Box className="flex w-full gap-4">
            <Button
              onClick={onUpload}
              className={twMerge(
                'h-[50px] w-full text-w-gray-600',
                'desktop:w-[160px]'
              )}
              size="md"
            >
              <SystemIcon name="medium_upload" className="text-w-gray-600" />
              사진 올리기
            </Button>
            <Button
              onClick={onDelete}
              className={twMerge(
                'h-[50px] w-full text-w-gray-600',
                'desktop:w-[160px]'
              )}
              size="md"
            >
              <SystemIcon name="medium_trash" className="text-w-gray-600" />
              사진 지우기
            </Button>
          </Box>
        </Box>
      </Box>
      <Box>
        <Box className="bg-w-gray-10 px-8 py-4">
          <NotificationList
            texts={[
              '프로필 사진은 요즘IT 서비스에 표시됩니다.',
              '8MB 이하의 JPG, JPEG, PNG만 업로드 가능합니다.',
            ]}
          />
        </Box>
        <Divider />
        <Box
          className={twJoin(
            'flex justify-between gap-4 px-8 py-5',
            'desktop:justify-end'
          )}
        >
          <Button
            onClick={onClose}
            variant="solid"
            className={twMerge(
              'w-full border-w-bluegray-200 bg-w-bluegray-200 focus:bg-w-bluegray-300 active:bg-w-bluegray-300 hover:border-w-bluegray-300 hover:bg-w-bluegray-300',
              'desktop:w-[89px]'
            )}
          >
            닫기
          </Button>
          <Button
            onClick={onSubmit}
            variant="solid"
            className={twMerge('w-full', 'desktop:w-[89px]')}
          >
            등록하기
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileImageForm;
